import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-mascaras-edit',
  templateUrl: './mascaras-edit.component.html',
  styleUrls: ['./mascaras-edit.component.css'],
  standalone: false
})
export class MascarasEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/mascaras`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Mascaras', link: '/mascaras' }, { label: 'Edição Mascaras' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'mascaras',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('mascaras').subscribe((data) => {
        this.fields = data;
    });
  }
}
